import React from 'react'
import Tab from '@mui/material/Tab'
import TabContext from '@mui/lab/TabContext'
import TabList from '@mui/lab/TabList'
import TabPanel from '@mui/lab/TabPanel'
import Paper from '@mui/material/Paper'
import Box from '@mui/material/Box'
import AppBar from '@mui/material/AppBar'

import FeedbackTab from '../tab/FeedbackTab'
import TopicEditorTab from '../tab/TopicEditorTab'
import QuestionEditorTab from '../tab/QuestionEditorTab'
import TreeTab from '../tab/TreeTab'

export default class EditorState extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      value: "3"
    }
  }

  handleChange(e, value) {
    this.setState({
      value: value
    })
  }

  render() {
    return <Paper sx={{ maxWidth: '95%', maxWidth: '1100px', margin: '100px auto' }}>
      <Box>
        <TabContext variant="fullWidth" value={this.state.value}>
          <AppBar position="static" color="default">

            <TabList variant="fullWidth" onChange={this.handleChange.bind(this)}>
              <Tab label="Topic Editor" value="1" />
              <Tab label="Question Editor" value="2" />
              <Tab label="Question Tree" value="3" />
              <Tab label="Feedback" value="4" />
            </TabList>
          </AppBar>
          <TabPanel value="1">
            <TopicEditorTab />
          </TabPanel>
          <TabPanel value="2">
            <QuestionEditorTab />
          </TabPanel>
          <TabPanel value="3" style={{ maxHeight: 'calc(100vh - 200px)', overflowY: 'scroll' }}>
            <TreeTab />
          </TabPanel>
          <TabPanel value="4">
            <FeedbackTab />
          </TabPanel>
        </TabContext>
      </Box>
    </Paper>
  }
}